/**
 * Declerations
 */
import axios from 'axios';
import moment from 'moment-timezone';


export default class Helper {

    /**
     * Windows resize listener
     */
     static windowresize(store) {
        const callback =  () => {
            

            const params = {
                width     : window.innerWidth,
                height    : window.innerHeight,
                breakpoint: this.windowbreakpoint()
            }

            store.commit('udpatewindowsize', params)
          }
          
        window.onresize = callback;
    }
    

    /**
     * Get window breakpoint
     * 
     */
    static windowbreakpoint() {
        let breakpoint = 'xs'
        // //get breakpoint
        // @if $size == 'sm' {
        //     // Small devices (landscape phones, 390px and up)
        //     @media (min-width: 390px) { @content; }
        // }
        
        // @if $size == 'md' {
        //     // Medium devices (tablets, 768px and up)
        //     @media (min-width: 768px) { @content; }
        // }
        
        // @if $size == 'lg' {
        //     // Large devices (desktops, 992px and up)
        //     @media (min-width: 992px) { @content; }
        // }
        
        // @if $size == 'xl' {
        //     // X-Large devices (large desktops, 1200px and up)
        //     @media (min-width: 1200px) { @content; }
        // }
       
        // @if $size == 'xxl' {
        //     // XX-Large devices (larger desktops, 1400px and up)
        //     @media (min-width: 1400px) { @content; }
        // }

       
        
       
        
        if(window.innerWidth >= 1400) {
            breakpoint = 'xxl'
        } else

        if(window.innerWidth >= 1200) {
            breakpoint = 'xl'
        } else 

        if(window.innerWidth >= 992) {
            breakpoint = 'lg'
        } else

        if(window.innerWidth >= 768) {
            breakpoint = 'md'
        } else
        

        if(window.innerWidth >= 390) {
            breakpoint = 'sm'
        } 


        return breakpoint
        
    }

    /**
     * Get user timezone
     * 
     */
    static usertimezone() {
        return moment.tz.guess()
    }

     /**
     * Check if US timezone
     */
      
     static isUStimezone() {
        return this.usertimezone().match(/America/i) ? true : false
     }

 
    /**
     * Return date string display
     * ref : https://momentjs.com/docs/#/displaying/calendar-time/
     * America/Boise
     * Asia/Manila
     */
    static datestring(date) {
        console.log('this.usertimezone() datestring', this.usertimezone())
        const isUStimezone = this.isUStimezone()
        const format       = 'MM/DD/YYYY'
        const parsingdate  = date
        const currentdate  = isUStimezone ? moment().format(format) :  moment().tz('America/Boise').format(format)
        const diff         = moment(parsingdate).diff(currentdate, 'days')
        
        let rel = date


        switch (diff) {
            case -1:
                rel = 'Yesterday'
                break;

            case 0:
                rel = 'Today'
                break;

            case 1:
                rel = 'Tomorrow'
                break;

        
            default:
                rel = this.formatdate(date, 'MM/DD/YYYY')
                break;
        }

        return  rel
    }
    
    /**
     * Format date with Mountain Standard Time
     * @param {String} date 
     * @param {String} format 
     */
    static formatdate(date, format, force = false) {
        const isUStimezone = force ? false : this.isUStimezone()
        const newdate      = force ? moment(date).utc() : moment(date).utc().format('MM/DD/YYYY hh:mm:ss A')
        // console.log(date, force, 'isUStimezone', isUStimezone)

        return isUStimezone  ? moment(newdate).utc().format(format) : moment(newdate).utc().tz('America/Boise').format(format)
    }
    
    /**
     * This will check if number is odd or even
     * @param {*} number 
     * @param {*} type 
     * @returns {Boolean}
     */
    static checkOddEven(number, type = 'odd') {

        if(type == 'odd') {
            return number % 2 == 0;
        } else {
            return Math.abs(number % 2) == 1;
        }
    }
    /**
     * Axios global configuration
     */
    static axoisglobalconfig() {
        /**
         * Set default base url
         */
        axios.defaults.baseURL = process.env.VUE_APP_APIROOT;

        /**
         * Set authorization token
         * @param {String} token
         */

        const token = this.getCookie('holesadmintoken');
        if(token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
    }
    /**
     * Adding Cookie
     * @param {String} cname cookies name
     * @param {String} cvalue cookies value
     * @param {Number} exdays expriation number of days
     */
    static  setCookie(cname, cvalue, exdays = 1) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    /**
     * Getting a cookie
     * @param {String} cname cookie name
     * @returns {String} cookie data
     */
    static getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');

        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }
    /**
     * Delete all cookies
     */
    static deleteAllCookies() {
        var cookies = document.cookie.split(";");
    
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }
    /**
     * Deleting specific cookie
     * @param {String} cname cookie name 
     */
    static deleteCookie(cname) {
        document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
    /**
     * Check if has session or expired session
     * @returns promise
     */
    static checksession() {
        const session = new Promise((resolve, reject) => {
             axios.get('/profile')
                .then(res => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                })
        });

        return session;
    }
    /**
     * Serialize Function
     * Used in JSON Stringify
     * @param {*} key
     * @param {Function} value 
     * @returns string
     */
    static serialize(key, value) {
		if (typeof value === 'function') {
			return value.toString();
		}
		return value;
	}
	/**
     * Deserialize Function
     * @param {*} key 
     * @param {function} value 
     * @returns function
     */
	static deserialize(key, value) {
		if (value && typeof value === "string" && value.substr(0, 8) == "function") {
			var startBody = value.indexOf('{') + 1;
			var endBody   = value.lastIndexOf('}');
			var startArgs = value.indexOf('(') + 1;
			var endArgs = value.indexOf(')');
	
			return new Function(value.substring(startArgs, endArgs), value.substring(startBody, endBody));
		}
		return value;
	} 

    static test123() {
        return 'testing123123';
    }

       /**
     * Get device type or name
     */
        static getdevicetype(type = 'device') {
            let deviceName = '';
            // Device type
            const isMobile = {
                Android: () => {
                    return navigator.userAgent.match(/Android/i);
                },
                Datalogic: () => {
                    return navigator.userAgent.match(/DL-AXIS/i);
                },
                Bluebird: () => {
                    return navigator.userAgent.match(/EF500/i);
                },
                Honeywell: () => {
                    return navigator.userAgent.match(/CT50/i);
                },
                Zebra: () => {
                    return navigator.userAgent.match(/TC70|TC55/i);
                },
                BlackBerry: () => {
                    return navigator.userAgent.match(/BlackBerry/i);
                },
                iOS: () => {
                    return navigator.userAgent.match(/iPhone|iPad|iPod|Macintosh/i);
                },
                Windows: () => {
                    return navigator.userAgent.match(/IEMobile/i);
                },
                any: () => {
                    return (isMobile.Datalogic() || isMobile.Bluebird() || isMobile.Honeywell() || isMobile.Zebra() || isMobile.BlackBerry() || isMobile.Android() || isMobile.iOS() || isMobile.Windows());
                }
            }
    
    
            if (isMobile.Datalogic())
                deviceName = 'Datalogic';
            else if (isMobile.Bluebird())
                deviceName = 'Bluebird';
            else if (isMobile.Honeywell())
                deviceName = 'Honeywell';
            else if (isMobile.Zebra())
                deviceName = 'Zebra';
            else if (isMobile.BlackBerry())
                deviceName = 'BlackBerry';
            else if (isMobile.iOS())
                deviceName = 'iOS';
            else if ((deviceName == '') && (isMobile.Android()))
                deviceName = 'Android';
            else if ((deviceName == '') && (isMobile.Windows()))
                deviceName = 'Windows';
    
            
            // Browser name
            let browsername = '';
    
            const browser = {
                chrome : () => {
                    return navigator.userAgent.match(/Chrome/i)
                },
                firefox : () => {
                    return navigator.userAgent.match(/Firefox/i)
                },
                safari : () => {
                    return navigator.userAgent.match(/Safari/i)
                },
                ie : () => {
                    return navigator.userAgent.match(/MSIE|Trident/i)
                }
            }
    
            if(browser.chrome) {
                browsername = 'Chrome'
            } else if(browser.safari) {
                browsername = 'Safari'
            } else if(browser.firefox) {
                browsername = 'Firefox'
            } else if(browser.ie) {
                browsername = "Internet Explorer"
            }
    
            let result = deviceName
    
            if(type == 'device') {
                result =  deviceName
            } else {
                result =  browsername
            }
    
            return result;
    
        }
    
}